import axiosInstance from "@/utils/axiosInstance";

const baseUrl = `api/badge-orders`;

const state = {};

const getters = {};

const mutations = {};

const actions = {
  getPricing({ commit }) {
    return axiosInstance.get(`${baseUrl}/pricing`, {
      params: {},
    }).then((data) => data.data);
  },
};

export default {
  namespaced: true, state, getters, actions, mutations,
};
